import React from 'react';
import { toast } from 'react-toastify';

const CustomToast = ({ onClick }) => {
    const handleButtonClick = () => {
        // Handle button click action here
        // For example, you can close the toast
        onClick();
        toast.dismiss();
    };

    return (
        <div className='d-flex justify-content-center align-items-center flex-column gap-3'>
            <div className='f600-24px'>Not a Registered User</div>
            <div className='f600-16px text-center' style={{
                color: 'rgba(104, 104, 104, 1)'
            }}>
            Please Register yourself to complete your booking, your data will be saved
            </div>
            <div className='f600-16px register-button m-2 cursor-pointer' onClick={handleButtonClick}>
                Register
            </div>
        </div>
    );
};

export default CustomToast;
